import React from 'react';
export function EditorStyleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.293 2.293a1 1 0 011.414 0L19.414 12 10 21.414 1.586 13l8-8-1.293-1.293a1 1 0 010-1.414zM11 6.414L7.707 9.707l5.586 5.586L16.586 12 11 6.414z"
  }), React.createElement("path", {
    d: "M19 15l-1.781 2.672C16.27 19.094 17.29 21 19 21s2.73-1.906 1.781-3.328L19 15z"
  }));
}